import React, { useState } from 'react';
import { Modal, Sidebar } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import CloseIcon from './CloseIcon';

const prefix = 'signatureFailed';

export function SignatureFailed({ errorMessage, handleSidebarClose }) {
  const [showModal, setShowModal] = useState(true);
  const helpMail = window.config.supportEmail;
  const handleClose = () => {
    handleSidebarClose();
    setShowModal(false);
  };

  return (
    <div>
      <Sidebar animation="overlay" direction="right" width="very wide" visible={showModal} className="side-bar">
        <CloseIcon handleClose={handleClose} />
        <div className="signature-result-sidebar">
          <h2 className="ui header">
            <FormattedMessage
              id={`${prefix}.info`}
              defaultMessage="Unfortunately, Submit electronic signature has failed"
            />
          </h2>
          <div className="sub-header"> {errorMessage} </div>
          <Modal.Actions>
            <FormattedMessage
              id="common.reachOutTo"
              defaultMessage={`Please reach out to ${helpMail}`}
              values={{ helpMail }}
            />
          </Modal.Actions>
        </div>
      </Sidebar>
    </div>
  );
}
